import { SET_COURSES_TO_ADD } from '../constants/general';

export function setCoursesToAdd(courseArray) {
  return ({
    type: SET_COURSES_TO_ADD,
    courseArray: courseArray
  })
}



// WEBPACK FOOTER //
// ./src/actions/general.js